export default function useLocaleIso() {
  const { locale, locales } = useI18n()

  const localeIsoCode = computed(
    () =>
      locales.value.find((l) => l.code === locale.value)?.language || 'en-US'
  )

  return { locale, locales, localeIsoCode }
}
